<template>
  <g class="tooltips">
    <rect
      v-for="(datum, index) in d"
      :x="p.scaleX(datum[c.xAxis])"
      :y="
        previousSerie
          ? (p.scaleY(datum[serie.key]) + p.scaleY(datum[previousSerie.key])) /
            2
          : (p.scaleY(datum[serie.key]) + p.scaleY(p.minY)) / 2
      "
      :key="'rect-tooltip-' + serie.key + index"
      :class="['tooltip', { visible: serie.key === hoveredStacked }]"
      :transform="`translate(12, -22)`"
      :width="hoveredStacked === serie.key ? computedWidth() : null"
    ></rect>
    <text
      v-for="(datum, index) in d"
      :key="'number-tooltip-' + index"
      :x="p.scaleX(datum[c.xAxis])"
      :y="
        previousSerie
          ? (p.scaleY(datum[serie.key]) + p.scaleY(datum[previousSerie.key])) /
            2
          : (p.scaleY(datum[serie.key]) + p.scaleY(p.minY)) / 2
      "
      :class="['text-number', { visible: serie.key === hoveredStacked }]"
      :transform="`translate(22, -5)`"
      fill="var(--primary-yellow)"
      >{{ $n(+datum[serie.key + "_label"].toFixed(0)) }}</text
    >
    <text
      v-for="(datum, index) in d"
      :key="'label-tooltip-' + index"
      :id="'serie' + serie.key"
      :x="p.scaleX(datum[c.xAxis])"
      :y="
        previousSerie
          ? (p.scaleY(datum[serie.key]) + p.scaleY(datum[previousSerie.key])) /
            2
          : (p.scaleY(datum[serie.key]) + p.scaleY(p.minY)) / 2
      "
      :class="['text-serie', { visible: serie.key === hoveredStacked }]"
      transform="translate(22, 13)"
      fill="#fff"
      >{{ serie.key }}</text
    >
  </g>
</template>

<script>
import { mapGetters } from "vuex";
import wrap from "@/charts/mixins/wrap.js";

export default {
  name: "TooltipStackedArea",
  props: ["p", "c", "d", "serie", "previousSerie"],
  mixins: [wrap],
  computed: {
    ...mapGetters({
      hoveredStacked: "ui/hoveredStacked",
    }),
  },
  methods: {
    computedWidth() {
      if (this.serie.key.toLowerCase() === "ultra light") {
        let width = this.measureText(this.serie.key, 17);
        return width + "px";
      }
      let width = this.measureText(this.serie.key, 16);
      return width + "px";
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltips {
  .tooltip {
    height: toRem(44);
    fill: var(--source-color-dark);
    transition: all 0.3s ease;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    &.visible {
      opacity: 1;
      visibility: visible;
    }
  }

  .text-serie {
    @include dida-S;
    transition: all 0.3s ease;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    &.visible {
      opacity: 1;
      visibility: visible;
    }
  }

  .text-number {
    @extend .text-serie;
    @include number-S;
  }
}
</style>
